import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// 到货模块
const ArrivalList = () => import('../views/arrival/List.vue')
const ArrivalDetail = () => import('../views/arrival/Detail.vue')

// 上架模块
const PutShelfList = () => import('../views/putShelf/List.vue')
const PutShelfDetail = () => import('../views/putShelf/Detail.vue')

// 配货模块
const AllocationList = () => import('../views/allocation/List.vue')

// New-配货模块
const NewAllocationList = () => import('../views/newAllocation/List.vue')
const NewAllocationDetail = () => import('../views/newAllocation/Detail.vue')

// 核对小标模块
const SmallLabelCheckList = () => import('../views/smallLabelCheck/List.vue')
const SmallLabelCheckDetail = () => import('../views/smallLabelCheck/Detail.vue')
const SmallLabelCheckIndex = () => import('../views/smallLabelCheck/Index.vue')
const SecondaryPackagingIndex = () => import('../views/secondaryPackaging/Index.vue')

// New-打包模块
const NewPackingList = () => import('../views/newPacking/List.vue')
const NewPackingShipmentList = () => import('../views/newPacking/ShipmentList.vue')
const NewPackingBoxList = () => import('../views/newPacking/BoxList.vue')
const NewPackingBoxDetail = () => import('../views/newPacking/BoxDetail.vue')

// 打包模块
const PackingList = () => import('../views/packing/List.vue')
const ShipmentList = () => import('../views/packing/ShipmentList.vue')
const BoxList = () => import('../views/packing/BoxList.vue')
const BoxDetail = () => import('../views/packing/BoxDetail.vue')
const PackingDetail = () => import('../views/packing/Detail.vue')

// 贴箱唛模块
const LabelingList = () => import('../views/labeling/List.vue')
const LabelingBoxList = () => import('../views/labeling/BoxList.vue')
const LabelingBoxDetail = () => import('../views/labeling/BoxDetail.vue')

// New-贴箱唛模块
const NewLabelingList = () => import('../views/newLabeling/List.vue')
const NewLabelingBoxList = () => import('../views/newLabeling/BoxList.vue')
const NewLabelingBoxDetail = () => import('../views/newLabeling/BoxDetail.vue')

// 盘点模块
const InventoryIndex = () => import('../views/inventory/Index.vue')
const InventoryList = () => import('../views/inventory/List.vue')
const InventoryDetail = () => import('../views/inventory/Detail.vue')
const NoPurchaseOrder = () => import('../views/inventory/NoPurchaseOrder.vue')
const NoPurchaseOrderDetail = () => import('../views/inventory/NoPurchaseOrderDetail.vue')
const ScanInventory = () => import('../views/inventory/ScanInventory.vue')
const ScanInventoryDetail = () => import('../views/inventory/ScanInventoryDetail.vue')

// 业务库存模块
const BusinessInventoryList = () => import('../views/businessInventory/List.vue')
const BusinessInventoryDetail = () => import('../views/businessInventory/Detail.vue')
const LocationTransfer = () => import('../views/locationTransfer/Index.vue')

// 运费提报模块
const FreightReport = () => import('../views/freightReport/Index.vue')

// 新品拍摄模块
const NewProductIndex = () => import('../views/newProduct/Index.vue')
const ArrivalExceptionAdjustment = () => import('../views/arrivalExceptionAdjustment/Index.vue')
import DongguanIndex from '../views/newProduct/DongguanIndex.vue'
const BeiyangList = () => import('../views/newProduct/BeiyangList.vue')
const BeiyangDetail = () => import('../views/newProduct/BeiyangDetail.vue')
const ChangshaList = () => import('../views/newProduct/ChangshaList.vue')
const ChangshaDetail = () => import('../views/newProduct/ChangshaDetail.vue')

// 首页
const Home = () => import('../views/home.vue')
const SkuScan = () => import('../views/skuScan/Index.vue')
const OutboundHandoverList = () => import('../views/outboundHandover/List.vue')
const OutboundHandoverDetail = () => import('../views/outboundHandover/Detail.vue')

const routes = [
  { path: '/sku-scan', name: 'SkuScan', component: SkuScan },
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  { path: '/outbound-handover/list', name: 'OutboundHandoverList', component: OutboundHandoverList },
  { path: '/outbound-handover/detail', name: 'OutboundHandoverDetail', component: OutboundHandoverDetail },
  // 到货模块路由
  {
    path: '/arrival/list',
    name: 'ArrivalList',
    component: ArrivalList
  },
  {
    path: '/arrival/detail',
    name: 'ArrivalDetail',
    component: ArrivalDetail
  },
  // 上架模块路由
  {
    path: '/putShelf/list',
    name: 'PutShelfList',
    component: PutShelfList
  },
  {
    path: '/putShelf/detail',
    name: 'PutShelfDetail',
    component: PutShelfDetail
  },
  // 配货模块路由
  {
    path: '/allocation/list',
    name: 'AllocationList',
    component: AllocationList
  },
  // New-配货模块路由
  {
    path: '/new-allocation/list',
    name: 'NewAllocationList',
    component: NewAllocationList
  },
  {
    path: '/new-allocation/detail',
    name: 'NewAllocationDetail',
    component: NewAllocationDetail
  },
  // 核对小标模块路由
  {
    path: '/small-label-check',
    name: 'SmallLabelCheckIndex',
    component: SmallLabelCheckIndex
  },
  {
    path: '/small-label-check/list',
    name: 'SmallLabelCheckList',
    component: SmallLabelCheckList
  },
  {
    path: '/small-label-check/detail',
    name: 'SmallLabelCheckDetail',
    component: SmallLabelCheckDetail
  },
  {
    path: '/small-label-check/feedback-list',
    name: 'SmallLabelFeedbackList',
    component: SmallLabelCheckList,
    props: { feedback: true }
  },
  {
    path: '/secondary-packaging',
    name: 'SecondaryPackagingIndex',
    component: SecondaryPackagingIndex
  },
  // New-打包模块路由
  {
    path: '/new-packing/list',
    name: 'NewPackingList',
    component: NewPackingList
  },
  {
    path: '/new-packing/shipment-list',
    name: 'NewPackingShipmentList',
    component: NewPackingShipmentList
  },
  {
    path: '/new-packing/box-list',
    name: 'NewPackingBoxList',
    component: NewPackingBoxList
  },
  {
    path: '/new-packing/box-detail',
    name: 'NewPackingBoxDetail',
    component: NewPackingBoxDetail
  },
  // 打包模块路由
  {
    path: '/packing/list',
    name: 'PackingList',
    component: PackingList
  },
  {
    path: '/packing/shipment-list',
    name: 'ShipmentList',
    component: ShipmentList
  },
  {
    path: '/packing/box-list',
    name: 'BoxList',
    component: BoxList
  },
  {
    path: '/packing/box-detail',
    name: 'BoxDetail',
    component: BoxDetail
  },
  {
    path: '/packing/detail',
    name: 'PackingDetail',
    component: PackingDetail
  },
  // 贴箱唛模块路由
  {
    path: '/labeling/list',
    name: 'LabelingList',
    component: LabelingList
  },
  {
    path: '/labeling/box-list',
    name: 'LabelingBoxList',
    component: LabelingBoxList
  },
  {
    path: '/labeling/box-detail',
    name: 'LabelingBoxDetail',
    component: LabelingBoxDetail
  },
  // New-贴箱唛模块路由
  {
    path: '/new-labeling/list',
    name: 'NewLabelingList',
    component: NewLabelingList
  },
  {
    path: '/new-labeling/box-list',
    name: 'NewLabelingBoxList',
    component: NewLabelingBoxList
  },
  {
    path: '/new-labeling/box-detail',
    name: 'NewLabelingBoxDetail',
    component: NewLabelingBoxDetail
  },
  // 盘点模块路由
  {
    path: '/inventory/index',
    name: 'InventoryIndex',
    component: InventoryIndex
  },
  {
    path: '/inventory/list',
    name: 'InventoryList',
    component: InventoryList
  },
  {
    path: '/inventory/detail',
    name: 'InventoryDetail',
    component: InventoryDetail
  },
  {
    path: '/inventory/no-purchase-order',
    name: 'NoPurchaseOrder',
    component: NoPurchaseOrder
  },
  {
    path: '/inventory/no-purchase-order-detail',
    name: 'NoPurchaseOrderDetail',
    component: NoPurchaseOrderDetail
  },
  {
    path: '/inventory/scan-inventory',
    name: 'ScanInventory',
    component: ScanInventory
  },
  {
    path: '/inventory/scan-inventory-detail',
    name: 'ScanInventoryDetail',
    component: ScanInventoryDetail
  },
  // 业务库存模块路由
  {
    path: '/business-inventory/list',
    name: 'BusinessInventoryList',
    component: BusinessInventoryList
  },
  {
    path: '/business-inventory/detail',
    name: 'BusinessInventoryDetail',
    component: BusinessInventoryDetail
  },
  {
    path: '/location-transfer',
    name: 'LocationTransfer',
    component: LocationTransfer
  },
  // 运费提报模块路由
  {
    path: '/freight-report',
    name: 'FreightReport',
    component: FreightReport
  },
  // 新品拍摄模块路由
  {
    path: '/new-product/index',
    name: 'NewProductIndex',
    component: NewProductIndex
  },
  {
    path: '/arrival-exception-adjustment',
    name: 'ArrivalExceptionAdjustment',
    component: ArrivalExceptionAdjustment
  },
  {
    path: '/warehouse-complaint',
    name: 'WarehouseComplaint',
    component: () => import('../views/warehouseComplaint/Index.vue')
  },
  {
    path: '/new-product/dongguan-index',
    name: 'DongguanIndex',
    component: DongguanIndex
  },
  {
    path: '/new-product/beiyang-list',
    name: 'BeiyangList',
    component: BeiyangList
  },
  {
    path: '/new-product/beiyang-detail',
    name: 'BeiyangDetail',
    component: BeiyangDetail
  },
  {
    path: '/new-product/changsha-list',
    name: 'ChangshaList',
    component: ChangshaList
  },
  {
    path: '/new-product/changsha-detail',
    name: 'ChangshaDetail',
    component: ChangshaDetail
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
